// removed by extract-text-webpack-plugin
module.exports = {"container":"_8d9a549323_src-housingCorporations-TheMap-_Resizer_container"};


//////////////////
// WEBPACK FOOTER
// ./src/housingCorporations/TheMap/Resizer.css
// module id = 887
// module chunks = 0